// --- Grade 11 & 12 Advanced Science Quiz Pool ---
// Structure: { subject: { grade: { topic: [questions] } } }

export const AdvanceScienceQuizPool = {
    Biology: {
        11: {
          "Cells & Cellular Processes": [
            {
              question: "Which organelle is responsible for producing ATP in eukaryotic cells?",
              correctAnswer: "Mitochondria",
              options: ["Chloroplast", "Ribosome", "Mitochondria"],
            },
            {
              question: "Prokaryotic cells lack which of the following?",
              correctAnswer: "A membrane-bound nucleus",
              options: [
                "Ribosomes",
                "A membrane-bound nucleus",
                "DNA",
              ],
            },
            {
              question: "Which component forms the basic framework of cell membranes?",
              correctAnswer: "Phospholipids",
              options: ["Proteins", "Cholesterol", "Phospholipids"],
            },
            {
              question: "Which process in cells produces the most ATP?",
              correctAnswer: "Aerobic respiration",
              options: ["Glycolysis", "Aerobic respiration", "Fermentation"],
            },
            {
              question: "What structure regulates the movement of materials into and out of the cell?",
              correctAnswer: "Cell membrane",
              options: ["Nucleus", "Cell membrane", "Cell wall"],
            },
          ],
          "Genetics & Inheritance": [
            {
              question: "If both parents are heterozygous for a recessive trait, what is the chance their child will express the trait?",
              correctAnswer: "25%",
              options: ["0%", "25%", "50%"],
            },
            {
              question: "What molecule carries genetic information from the nucleus to the ribosome?",
              correctAnswer: "mRNA",
              options: ["tRNA", "rRNA", "mRNA"],
            },
            {
              question: "Which type of inheritance pattern results in both alleles being expressed equally?",
              correctAnswer: "Codominance",
              options: ["Incomplete dominance", "Codominance", "Polygenic"],
            },
            {
              question: "What is the expected genotypic ratio of a monohybrid cross between two heterozygotes (Aa x Aa)?",
              correctAnswer: "1:2:1",
              options: ["3:1", "1:2:1", "9:3:3:1"],
            },
            {
              question: "Which technology allows scientists to edit specific genes in organisms?",
              correctAnswer: "CRISPR-Cas9",
              options: ["PCR", "Gel electrophoresis", "CRISPR-Cas9"],
            },
          ],
          "Evolution & Biodiversity": [
            {
              question: "Which process is most responsible for genetic variation in populations?",
              correctAnswer: "Mutation",
              options: ["Mutation", "Mitosis", "Natural selection"],
            },
            {
              question: "The idea that species evolve by the gradual accumulation of small changes was proposed by?",
              correctAnswer: "Charles Darwin",
              options: ["Gregor Mendel", "Charles Darwin", "Rosalind Franklin"],
            },
            {
              question: "What is the role of a keystone species in an ecosystem?",
              correctAnswer: "It has a disproportionately large impact on its environment",
              options: [
                "It is always the most abundant species",
                "It has a disproportionately large impact on its environment",
                "It is always a predator"
              ],
            },
            {
              question: "Which evolutionary mechanism involves random changes in allele frequencies in small populations?",
              correctAnswer: "Genetic drift",
              options: ["Natural selection", "Gene flow", "Genetic drift"],
            },
            {
              question: "What type of speciation occurs when a population is geographically divided?",
              correctAnswer: "Allopatric speciation",
              options: ["Sympatric speciation", "Allopatric speciation", "Polyploidy"],
            },
          ],
        },
        12: {
          "Molecular Genetics": [
            {
              question: "What enzyme unwinds DNA during replication?",
              correctAnswer: "Helicase",
              options: ["Ligase", "Polymerase", "Helicase"],
            },
            {
              question: "A mutation that changes a single nucleotide in DNA is called a?",
              correctAnswer: "Point mutation",
              options: ["Frameshift mutation", "Point mutation", "Deletion mutation"],
            },
            {
              question: "The process by which mRNA is synthesized from DNA is called?",
              correctAnswer: "Transcription",
              options: ["Translation", "Replication", "Transcription"],
            },
            {
              question: "What is the function of tRNA during translation?",
              correctAnswer: "It brings amino acids to the ribosome",
              options: [
                "It synthesizes proteins",
                "It brings amino acids to the ribosome",
                "It edits mRNA"
              ],
            },
            {
              question: "Which biotechnology method is used to amplify segments of DNA?",
              correctAnswer: "PCR",
              options: ["CRISPR", "PCR", "Cloning"],
            },
          ],
          "Homeostasis & Physiology": [
            {
              question: "Which hormone lowers blood glucose levels?",
              correctAnswer: "Insulin",
              options: ["Glucagon", "Insulin", "Adrenaline"],
            },
            {
              question: "Where does gas exchange occur in the human lungs?",
              correctAnswer: "Alveoli",
              options: ["Bronchi", "Alveoli", "Trachea"],
            },
            {
              question: "Which organ is primarily responsible for filtering waste from the blood?",
              correctAnswer: "Kidney",
              options: ["Liver", "Lung", "Kidney"],
            },
            {
              question: "What is the main function of hemoglobin?",
              correctAnswer: "Transporting oxygen",
              options: [
                "Digesting proteins",
                "Transporting oxygen",
                "Transmitting nerve signals"
              ],
            },
            {
              question: "Which part of the brain controls balance and coordination?",
              correctAnswer: "Cerebellum",
              options: ["Cerebrum", "Cerebellum", "Medulla"],
            },
          ],
          "Ecology & Sustainability": [
            {
              question: "Which term best describes a group of different species living in the same area?",
              correctAnswer: "Community",
              options: ["Population", "Community", "Ecosystem"],
            },
            {
              question: "The main cause of the enhanced greenhouse effect is?",
              correctAnswer: "Increase in atmospheric CO₂",
              options: [
                "Decrease in solar radiation",
                "Increase in atmospheric CO₂",
                "More rainfall",
              ],
            },
            {
              question: "What is the term for a species that is not native and causes harm to the ecosystem?",
              correctAnswer: "Invasive species",
              options: ["Endemic species", "Invasive species", "Keystone species"],
            },
            {
              question: "Which process is essential for nitrogen fixation in ecosystems?",
              correctAnswer: "Bacteria in soil convert N₂ into usable forms",
              options: [
                "Plants absorb N₂ directly",
                "Bacteria in soil convert N₂ into usable forms",
                "Animals excrete N₂ gas"
              ],
            },
            {
              question: "What is the best example of a sustainable practice?",
              correctAnswer: "Crop rotation",
              options: ["Deforestation", "Overfishing", "Crop rotation"],
            },
          ],
        },
      },
  
    Chemistry: {
        11: {
          "Atomic Theory & Structure": [
            {
              question: "What is the maximum number of electrons in the third energy level?",
              correctAnswer: "18",
              options: ["8", "18", "32"],
            },
            {
              question: "Which element has the highest electronegativity?",
              correctAnswer: "Fluorine",
              options: ["Oxygen", "Fluorine", "Chlorine"],
            },
            {
              question: "What do isotopes of an element differ in?",
              correctAnswer: "Number of neutrons",
              options: [
                "Number of protons",
                "Number of neutrons",
                "Number of electrons",
              ],
            },
            {
              question: "The atomic number of an atom equals its number of:",
              correctAnswer: "Protons",
              options: ["Protons", "Neutrons", "Electrons"],
            },
            {
              question: "Which periodic trend increases across a period from left to right?",
              correctAnswer: "Electronegativity",
              options: ["Atomic radius", "Electronegativity", "Metallic character"],
            },
          ],
          "Bonding & Molecular Shapes": [
            {
              question: "An ionic bond is formed between:",
              correctAnswer: "A metal and a non-metal",
              options: [
                "Two non-metals",
                "A metal and a non-metal",
                "Two metals",
              ],
            },
            {
              question: "Which bond is the strongest?",
              correctAnswer: "Covalent bond",
              options: [
                "Hydrogen bond",
                "Ionic bond",
                "Covalent bond",
              ],
            },
            {
              question: "What is the shape of a water (H₂O) molecule according to VSEPR theory?",
              correctAnswer: "Bent",
              options: ["Linear", "Bent", "Trigonal planar"],
            },
            {
              question: "What type of bond involves sharing of electrons?",
              correctAnswer: "Covalent bond",
              options: [
                "Ionic bond",
                "Metallic bond",
                "Covalent bond",
              ],
            },
            {
              question: "What term describes the attraction between molecules due to temporary dipoles?",
              correctAnswer: "London dispersion forces",
              options: [
                "Hydrogen bonding",
                "Dipole-dipole forces",
                "London dispersion forces",
              ],
            },
          ],
          "Stoichiometry & Reactions": [
            {
              question: "Which law states that mass is neither created nor destroyed in a chemical reaction?",
              correctAnswer: "Law of conservation of mass",
              options: [
                "Law of definite proportions",
                "Law of conservation of mass",
                "Law of multiple proportions",
              ],
            },
            {
              question: "How many moles are in 18g of water (H₂O)? (Molar mass H₂O = 18g/mol)",
              correctAnswer: "1 mole",
              options: ["1 mole", "9 moles", "18 moles"],
            },
            {
              question: "What is the product of a neutralization reaction between HCl and NaOH?",
              correctAnswer: "NaCl and H₂O",
              options: [
                "NaCl and H₂O",
                "NaClO and H₂",
                "H₂ and Cl₂",
              ],
            },
            {
              question: "What is the coefficient for O₂ when this equation is balanced? ___C₃H₈ + ___O₂ → ___CO₂ + ___H₂O",
              correctAnswer: "5",
              options: ["3", "4", "5"],
            },
            {
              question: "What is Avogadro’s number?",
              correctAnswer: "6.02 x 10²³",
              options: [
                "3.00 x 10⁸",
                "6.02 x 10²³",
                "1.67 x 10⁻²⁴",
              ],
            },
          ],
          "Solutions, Acids & Bases": [
            {
              question: "A solution with a pH of 2 is considered:",
              correctAnswer: "Strongly acidic",
              options: [
                "Strongly acidic",
                "Neutral",
                "Strongly basic",
              ],
            },
            {
              question: "Which of the following is a base?",
              correctAnswer: "NaOH",
              options: [
                "NaCl",
                "NaOH",
                "HCl",
              ],
            },
            {
              question: "What term describes the amount of solute dissolved in a given volume of solution?",
              correctAnswer: "Concentration",
              options: [
                "Concentration",
                "Dilution",
                "Neutralization",
              ],
            },
            {
              question: "According to the Arrhenius definition, acids produce ___ in solution.",
              correctAnswer: "H⁺ ions",
              options: [
                "OH⁻ ions",
                "H⁺ ions",
                "Na⁺ ions",
              ],
            },
            {
              question: "What is the product when hydrochloric acid reacts with sodium carbonate?",
              correctAnswer: "CO₂, H₂O, and NaCl",
              options: [
                "CO₂, H₂O, and NaCl",
                "NaOH and HCl",
                "NaCl and H₂",
              ],
            },
          ],
          "Thermochemistry & Energy": [
            {
              question: "Which reaction releases heat to the surroundings?",
              correctAnswer: "Exothermic",
              options: [
                "Exothermic",
                "Endothermic",
                "Isothermal",
              ],
            },
            {
              question: "The energy required to start a reaction is called:",
              correctAnswer: "Activation energy",
              options: [
                "Enthalpy",
                "Activation energy",
                "Entropy",
              ],
            },
            {
              question: "What device is used to measure heat changes in a reaction?",
              correctAnswer: "Calorimeter",
              options: [
                "Barometer",
                "Calorimeter",
                "Thermocouple",
              ],
            },
            {
              question: "Which law states that energy cannot be created or destroyed?",
              correctAnswer: "Law of conservation of energy",
              options: [
                "Law of conservation of mass",
                "Law of conservation of energy",
                "Hess’s law",
              ],
            },
            {
              question: "In an endothermic process, the system:",
              correctAnswer: "Absorbs heat",
              options: [
                "Releases heat",
                "Absorbs heat",
                "Loses mass",
              ],
            },
          ],
          "Modern Chemistry in Society": [
  {
    question: "Which principle is central to green chemistry?",
    correctAnswer: "Designing products and processes that minimize hazardous substances",
    options: [
      "Designing products and processes that minimize hazardous substances",
      "Maximizing energy use in chemical production",
      "Prioritizing cost over safety in chemical engineering",
    ],
  },
  {
    question: "Nanomaterials are increasingly used in modern technology. What is a unique property of nanomaterials?",
    correctAnswer: "They often have different chemical and physical properties than bulk materials",
    options: [
      "They are always metals",
      "They are visible without microscopes",
      "They often have different chemical and physical properties than bulk materials",
    ],
  },
  {
    question: "What is one way chemistry is addressing environmental pollution?",
    correctAnswer: "Developing biodegradable plastics",
    options: [
      "Increasing the use of fossil fuels",
      "Developing biodegradable plastics",
      "Promoting single-use plastics",
    ],
  },
  {
    question: "Why is chemistry important in the development of new medicines?",
    correctAnswer: "It enables the design and synthesis of molecules with specific biological effects",
    options: [
      "It guarantees all medicines are safe for everyone",
      "It enables the design and synthesis of molecules with specific biological effects",
      "It eliminates the need for clinical testing",
    ],
  },
  {
    question: "Which career involves monitoring air and water quality to protect public health?",
    correctAnswer: "Environmental chemist",
    options: [
      "Organic chemist",
      "Environmental chemist",
      "Nuclear physicist",
    ],
  },
],
        },
        12: {
            "Structure & Properties of Matter": [
              {
                question: "Which type of bond involves the sharing of electron pairs between atoms?",
                correctAnswer: "Covalent bond",
                options: ["Ionic bond", "Covalent bond", "Metallic bond"],
              },
              {
                question: "Which force is responsible for the boiling point differences between water and methane?",
                correctAnswer: "Intermolecular forces (hydrogen bonding)",
                options: [
                  "Ionic bonds",
                  "Intermolecular forces (hydrogen bonding)",
                  "Metallic bonds",
                ],
              },
              {
                question: "What is the electron configuration of a sodium (Na) atom?",
                correctAnswer: "1s² 2s² 2p⁶ 3s¹",
                options: [
                  "1s² 2s² 2p⁶",
                  "1s² 2s² 2p⁶ 3s¹",
                  "1s² 2s² 2p⁶ 3s²",
                ],
              },
              {
                question: "Which type of crystal structure is formed by table salt (NaCl)?",
                correctAnswer: "Face-centered cubic (FCC)",
                options: [
                  "Hexagonal close-packed (HCP)",
                  "Body-centered cubic (BCC)",
                  "Face-centered cubic (FCC)",
                ],
              },
              {
                question: "Which state of matter has particles with the greatest freedom of movement?",
                correctAnswer: "Gas",
                options: ["Solid", "Liquid", "Gas"],
              },
            ],
          
            "Chemical Kinetics & Equilibrium": [
              {
                question: "What does a catalyst do to a reaction?",
                correctAnswer: "Lowers activation energy",
                options: [
                  "Raises activation energy",
                  "Lowers activation energy",
                  "Has no effect",
                ],
              },
              {
                question: "When a reaction reaches equilibrium:",
                correctAnswer: "The forward and reverse reaction rates are equal",
                options: [
                  "Reactants are fully converted to products",
                  "The reaction stops",
                  "The forward and reverse reaction rates are equal",
                ],
              },
              {
                question: "Which of the following does NOT affect the rate of a chemical reaction?",
                correctAnswer: "Color of reactants",
                options: [
                  "Concentration",
                  "Temperature",
                  "Color of reactants",
                ],
              },
              {
                question: "Le Chatelier's Principle states that:",
                correctAnswer: "A system at equilibrium will shift to counteract a change",
                options: [
                  "Energy is always conserved",
                  "A system at equilibrium will shift to counteract a change",
                  "The reaction rate is constant",
                ],
              },
              {
                question: "If temperature increases for an exothermic reaction at equilibrium, the system will:",
                correctAnswer: "Shift toward reactants",
                options: [
                  "Shift toward products",
                  "Shift toward reactants",
                  "Remain unchanged",
                ],
              },
            ],
          
            "Acids, Bases & Electrochemistry": [
              {
                question: "A solution with pH = 2 is considered:",
                correctAnswer: "Strongly acidic",
                options: [
                  "Strongly acidic",
                  "Neutral",
                  "Strongly basic",
                ],
              },
              {
                question: "In a galvanic cell, electrons flow from:",
                correctAnswer: "Anode to cathode",
                options: ["Cathode to anode", "Anode to cathode", "Both ways"],
              },
              {
                question: "Which of the following is a strong base?",
                correctAnswer: "NaOH",
                options: ["NH₃", "NaOH", "H₂O"],
              },
              {
                question: "During electrolysis of water, which gas is released at the cathode?",
                correctAnswer: "Hydrogen",
                options: ["Oxygen", "Hydrogen", "Chlorine"],
              },
              {
                question: "What is the conjugate base of H₂SO₄?",
                correctAnswer: "HSO₄⁻",
                options: ["HSO₄⁻", "SO₄²⁻", "H₃O⁺"],
              },
            ],
          
            "Organic Chemistry": [
              {
                question: "Which functional group is found in alcohols?",
                correctAnswer: "-OH (hydroxyl group)",
                options: [
                  "-OH (hydroxyl group)",
                  "-COOH (carboxyl group)",
                  "-NH₂ (amine group)",
                ],
              },
              {
                question: "What is the general formula for alkanes?",
                correctAnswer: "CₙH₂ₙ₊₂",
                options: ["CₙH₂ₙ", "CₙH₂ₙ₊₂", "CₙH₂ₙ₋₂"],
              },
              {
                question: "Which of the following is a polymer?",
                correctAnswer: "Polyethylene",
                options: ["Ethanol", "Polyethylene", "Methane"],
              },
              {
                question: "The reaction of an alkene with hydrogen gas in the presence of a catalyst is called:",
                correctAnswer: "Hydrogenation",
                options: ["Hydration", "Hydrogenation", "Halogenation"],
              },
              {
                question: "Which compound is an isomer of C₄H₁₀?",
                correctAnswer: "2-methylpropane",
                options: ["Methanol", "2-methylpropane", "Cyclobutane"],
              },
            ],
          }          
      },
  
    Physics: {
        11: {
            "Kinematics & Dynamics": [
              {
                question: "Which quantity describes both speed and direction?",
                correctAnswer: "Velocity",
                options: ["Speed", "Distance", "Velocity"],
              },
              {
                question: "Newton’s Second Law is represented by which formula?",
                correctAnswer: "F = ma",
                options: ["F = mg", "F = ma", "F = mv"],
              },
              {
                question: "What is the acceleration due to gravity near Earth's surface?",
                correctAnswer: "9.8 m/s²",
                options: ["9.8 m/s²", "1.6 m/s²", "12 m/s²"],
              },
              {
                question: "A car travels 120 meters east in 10 seconds. What is its average velocity?",
                correctAnswer: "12 m/s east",
                options: ["12 m/s east", "10 m/s east", "120 m/s east"],
              },
              {
                question: "What force always acts opposite to the direction of motion?",
                correctAnswer: "Friction",
                options: ["Tension", "Gravity", "Friction"],
              },
            ],
            "Waves & Sound": [
              {
                question: "What property of a wave determines its pitch?",
                correctAnswer: "Frequency",
                options: ["Amplitude", "Frequency", "Wavelength"],
              },
              {
                question: "In sound, what type of wave travels through air?",
                correctAnswer: "Longitudinal wave",
                options: ["Transverse wave", "Longitudinal wave", "Surface wave"],
              },
              {
                question: "What is the distance between two consecutive wave crests called?",
                correctAnswer: "Wavelength",
                options: ["Amplitude", "Wavelength", "Period"],
              },
              {
                question: "The loudness of a sound depends primarily on which property of the wave?",
                correctAnswer: "Amplitude",
                options: ["Wavelength", "Amplitude", "Speed"],
              },
              {
                question: "What phenomenon explains why an ambulance siren sounds higher as it approaches you and lower as it moves away?",
                correctAnswer: "Doppler effect",
                options: ["Doppler effect", "Interference", "Diffraction"],
              },
            ],
            "Electricity & Magnetism": [
              {
                question: "Ohm's Law is given by:",
                correctAnswer: "V = IR",
                options: ["V = IR", "I = VR", "R = VI"],
              },
              {
                question: "What particle carries a negative charge?",
                correctAnswer: "Electron",
                options: ["Neutron", "Proton", "Electron"],
              },
              {
                question: "What device is used to measure electric current in a circuit?",
                correctAnswer: "Ammeter",
                options: ["Voltmeter", "Ammeter", "Galvanometer"],
              },
              {
                question: "What is produced around a wire when electric current flows through it?",
                correctAnswer: "A magnetic field",
                options: ["A magnetic field", "A sound wave", "Light"],
              },
              {
                question: "In a series circuit, what happens if one component fails?",
                correctAnswer: "The whole circuit stops working",
                options: [
                  "The whole circuit stops working",
                  "Other components continue to work",
                  "The current increases",
                ],
              },
            ],
          },
          12: {
            "Advanced Mechanics": [
              {
                question: "Which force keeps a satellite in orbit?",
                correctAnswer: "Gravitational force",
                options: [
                  "Frictional force",
                  "Gravitational force",
                  "Magnetic force",
                ],
              },
              {
                question: "A car moving in a circle at constant speed is experiencing:",
                correctAnswer: "Centripetal acceleration",
                options: [
                  "No acceleration",
                  "Centrifugal force",
                  "Centripetal acceleration",
                ],
              },
              {
                question: "Momentum is always conserved in:",
                correctAnswer: "All isolated systems",
                options: [
                  "Elastic collisions only",
                  "All isolated systems",
                  "Only explosions",
                ],
              },
              {
                question: "Work done on an object is zero if:",
                correctAnswer: "The force is perpendicular to displacement",
                options: [
                  "The force is parallel to displacement",
                  "The force is perpendicular to displacement",
                  "The object accelerates",
                ],
              },
              {
                question: "The unit of energy in the SI system is:",
                correctAnswer: "Joule",
                options: [
                  "Watt",
                  "Joule",
                  "Newton",
                ],
              },
            ],
            "Electricity, Magnetism & EM Waves": [
              {
                question: "The unit of electric current is:",
                correctAnswer: "Ampere",
                options: ["Coulomb", "Ampere", "Volt"],
              },
              {
                question: "A transformer works on which principle?",
                correctAnswer: "Electromagnetic induction",
                options: [
                  "Conservation of energy",
                  "Electromagnetic induction",
                  "Static electricity",
                ],
              },
              {
                question: "Which particle is responsible for current in metals?",
                correctAnswer: "Electron",
                options: ["Proton", "Neutron", "Electron"],
              },
              {
                question: "What phenomenon causes light to bend when passing from air into water?",
                correctAnswer: "Refraction",
                options: ["Reflection", "Refraction", "Diffraction"],
              },
              {
                question: "What is the main difference between AC and DC current?",
                correctAnswer: "Direction of flow changes in AC, remains constant in DC",
                options: [
                  "AC is weaker than DC",
                  "Direction of flow changes in AC, remains constant in DC",
                  "AC requires batteries, DC requires outlets",
                ],
              },
            ],
            "Quantum Physics & Relativity": [
              {
                question: "What is the famous equation from Einstein’s theory of relativity?",
                correctAnswer: "E = mc²",
                options: ["F = ma", "E = mc²", "V = IR"],
              },
              {
                question: "The photoelectric effect demonstrated that light behaves as:",
                correctAnswer: "Both a wave and a particle",
                options: [
                  "Only a wave",
                  "Only a particle",
                  "Both a wave and a particle",
                ],
              },
              {
                question: "Which quantum number describes the orientation of an orbital?",
                correctAnswer: "Magnetic quantum number (mℓ)",
                options: [
                  "Principal quantum number (n)",
                  "Magnetic quantum number (mℓ)",
                  "Spin quantum number (ms)",
                ],
              },
              {
                question: "In nuclear reactions, which particle is emitted during beta decay?",
                correctAnswer: "Electron",
                options: [
                  "Proton",
                  "Electron",
                  "Neutron",
                ],
              },
              {
                question: "What does the uncertainty principle state?",
                correctAnswer: "It is impossible to know both position and momentum exactly at the same time",
                options: [
                  "Energy cannot be created or destroyed",
                  "It is impossible to know both position and momentum exactly at the same time",
                  "Wave and particle properties are unrelated",
                ],
              },
            ],
            "Energy, Momentum & Collisions": [
  {
    question: "In a perfectly elastic collision, which quantities are conserved?",
    correctAnswer: "Both kinetic energy and momentum",
    options: [
      "Momentum only",
      "Kinetic energy only",
      "Both kinetic energy and momentum"
    ],
  },
  {
    question: "The area under a force vs. time graph represents:",
    correctAnswer: "Impulse",
    options: ["Momentum", "Impulse", "Work"],
  },
  {
    question: "Which formula represents the conservation of momentum in two dimensions?",
    correctAnswer: "m₁v₁ + m₂v₂ = m₁v₁' + m₂v₂'",
    options: [
      "F = ma",
      "m₁v₁ + m₂v₂ = m₁v₁' + m₂v₂'",
      "W = Fd"
    ],
  },
  {
    question: "Which of the following is true for an inelastic collision?",
    correctAnswer: "Momentum is conserved but kinetic energy is not",
    options: [
      "Both momentum and kinetic energy are conserved",
      "Momentum is conserved but kinetic energy is not",
      "Neither momentum nor kinetic energy is conserved"
    ],
  },
  {
    question: "A ball of mass 2 kg moving at 3 m/s collides elastically with a 1 kg stationary ball. Which law allows you to predict their final velocities?",
    correctAnswer: "Conservation of momentum and kinetic energy",
    options: [
      "Newton's second law only",
      "Conservation of momentum only",
      "Conservation of momentum and kinetic energy"
    ],
  },
],

"Waves & Modern Physics": [
  {
    question: "Which phenomenon shows that light can behave as a wave?",
    correctAnswer: "Diffraction",
    options: ["Photoelectric effect", "Diffraction", "Polarization"],
  },
  {
    question: "The Doppler effect explains:",
    correctAnswer: "Frequency change due to source or observer motion",
    options: [
      "Amplitude change with distance",
      "Reflection of waves",
      "Frequency change due to source or observer motion"
    ],
  },
  {
    question: "What is the dual nature of light?",
    correctAnswer: "Light behaves as both a particle and a wave",
    options: [
      "Light behaves only as a wave",
      "Light behaves only as a particle",
      "Light behaves as both a particle and a wave"
    ],
  },
  {
    question: "Which property of light changes when it passes from air into water?",
    correctAnswer: "Wavelength",
    options: ["Speed", "Frequency", "Wavelength"],
  },
  {
    question: "Which effect is direct evidence of the quantization of energy?",
    correctAnswer: "Photoelectric effect",
    options: ["Interference", "Photoelectric effect", "Polarization"],
  },
],

          },
    },
  };
  
  // --- Utility function for random quizzes by subject/grade/topic ---
  export function generateAdvancedScienceQuiz({ subject, grade, topic, count = 10 }) {
    // Aggregate ALL topics if "all" is requested:
    let pool = [];
    if (topic === "all") {
      const topicObj = AdvanceScienceQuizPool?.[subject]?.[grade];
      if (topicObj) {
        Object.values(topicObj).forEach(arr => { pool = pool.concat(arr); });
      }
    } else {
      pool = AdvanceScienceQuizPool?.[subject]?.[grade]?.[topic] || [];
    }
    if (!pool.length) return [];
    // Shuffle and pick count:
    const shuffled = pool
      .slice()
      .sort(() => Math.random() - 0.5)
      .slice(0, count);
    return shuffled;
  }
  